import actions from '@/core/store/ata/documentos-ata/actions'
import mutations from '@/core/store/ata/documentos-ata/mutations'
import state from '@/core/store/ata/documentos-ata/state'
import documentoEditorTexto from '@/core/store/ata/documentos-ata/documentos/editor-texto'
import documentoAnexo from '@/core/store/ata/documentos-ata/anexos'
import documentoProcessoDigital from '@/core/store/ata/documentos-ata/processo-digital'
import signatarios from '@/core/store/ata/documentos-ata/documentos/signatarios'

export default {
	actions,
	mutations,
	state,
	modules: {
		documentoEditorTexto,
		documentoAnexo,
		documentoProcessoDigital,
		signatarios,
	},
}
